const getContentPanelNode = () => `
    name
    addonKey
    moduleKey
    options
    iconUrl
    tooltip
    type
    isShownByDefault
    wasManuallyAddedToIssue
`;

const getContentPanelsConnectionQuery = () => `
    contentPanels {
        edges {
            node {
                ${getContentPanelNode()}
            }
        }
    }
`;

const getLegacyContentPanelsConnectionQuery = () => `
    legacyContentPanels {
        edges {
            node {
                ${getContentPanelNode()}
            }
        }
    }
`;

export const getContentPanelsQuery = () => `
    ${getContentPanelsConnectionQuery()}
    ${getLegacyContentPanelsConnectionQuery()}
    hasCustomisedContentPanels
`;
